/** Summarize repricer_articles.pricing_history for compact UI display. */

function entryDateKey(entry) {
  const raw = entry?.date;
  if (!raw) return null;
  if (typeof raw === "string") return raw.slice(0, 10);
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    return raw.toISOString().slice(0, 10);
  }
  return String(raw).slice(0, 10);
}

function latestEntryDate(entries) {
  let latest = null;
  for (const entry of entries) {
    const key = entryDateKey(entry);
    if (!key) continue;
    if (latest === null || key > latest) latest = key;
  }
  return latest;
}

/**
 * Compact per-channel summary, e.g. `otto: 47 · last 2026-11-04`.
 * History may hold up to ~100 entries/channel (n8n prune); do not list every date.
 */
export function formatPricingHistory(history) {
  if (!history || typeof history !== "object" || Array.isArray(history)) {
    return null;
  }

  const parts = Object.entries(history)
    .filter(([, entries]) => Array.isArray(entries) && entries.length > 0)
    .map(([channel, entries]) => {
      const count = entries.length;
      const last = latestEntryDate(entries);
      return last ? `${channel}: ${count} · last ${last}` : `${channel}: ${count}`;
    });

  return parts.length > 0 ? parts.join(" · ") : null;
}
